export default __webpack_public_path__ + "static/media/ridgeback.f00f955c.png";